// Mirrors Finkit.Permissions.User.FinkitUserPagesPermissions.TenantSettings.
export const EmailRecipientPermissions = {
  view: 'User.TenantSettings.EmailRecipients',
  create: 'User.TenantSettings.EmailRecipients.Create',
  update: 'User.TenantSettings.EmailRecipients.Update',
  delete: 'User.TenantSettings.EmailRecipients.Delete',
} as const;
